module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.346 20H10.652c-.592 0-.822-.404-.52-.902l5.316-8.724c.302-.498.796-.498 1.1 0l5.318 8.724c.304.498.072.902-.52.902z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-circle-1.js
// module id = 1473
// module chunks = 14